import React, { FC } from 'react';
import { motion } from 'framer-motion';

interface ReliabilityHospitalDashProps {
    hospitalDashData: any
}

const ReliabilityHospitalDash: FC<ReliabilityHospitalDashProps> = ({ hospitalDashData }) => {
    return (
        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 lg:gap-12 p-4 sm:p-6 md:p-8 lg:p-16 px-4 sm:px-8 md:px-16 lg:px-36'>
            {hospitalDashData.ReliabilityHosDashData.map((reliable: any, index: number) => {
                return (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false }}
                        transition={{ 
                            duration: 0.5, 
                            delay: index * 0.1,
                            ease: "easeOut"
                        }}
                        whileHover={{
                            scale: 1.05,
                            transition: { duration: 0.1, ease: "easeInOut" }
                        }}
                        className='bg-blackDark rounded-3xl group'
                    >
                        <div className='bg-blackDark flex flex-col items-start justify-center p-4 sm:p-6 relative overflow-hidden gap-2 rounded-3xl'>
                            <div className={`w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-blackDarkThemeSecondary text-white flex items-center justify-center font-bold text-xl sm:text-2xl group-hover:bg-${reliable.color} group-hover:text-black`}>{reliable.key}.</div>
                            <div className={`text-lg sm:text-xl text-start font-semibold mb-1 text-white group-hover:text-${reliable.color}`}>{reliable.title}</div>
                            <div className='text-lightGrey text-xs sm:text-sm'>{reliable.subtitle}</div>
                        </div>
                    </motion.div>
                )
            })}
        </div>
    )
}

export default ReliabilityHospitalDash
